import { ROUTE_URL, ARTICLE_KEY, VISITOR_PRIVILEGES, MAP_STORE_ICON } from 'basic/config'

export * from 'basic/config'

ROUTE_URL.ABOUT = '/about';
ROUTE_URL.STREAM = '/stream';
ROUTE_URL.INSTRUCTIONS = '/instructions';
ROUTE_URL.MARKETINGPLAN = '/marketingplan';


export { ROUTE_URL }

export const HAS_CART = true
export const HAS_DELIVERY = true
export const HAS_MESSAGES = true

export const REACT_APP_INDEX_URL="/";

export const GOODS_CATEGORY_MENU = true;

export const VISITOR_REDIRECT = [
  { pathname: null, privileges: VISITOR_PRIVILEGES.STORE, to: process.env.REACT_APP_ADMIN_URL },
  { pathname: null, privileges: VISITOR_PRIVILEGES.STOREKEEPER, to: process.env.REACT_APP_ADMIN_URL }
];

